import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { getStatsAuthors } from 'app/webview/pages/stats_profile/lib/utils'

export const AuthorsGridY = () => {
  const theme = useStatsTheme((s) => s.theme)
  const stats = useStats((s) => s.stats)
  const authors = getStatsAuthors(stats) || []

  return (
    <FlexBox
      className={css`
        max-width: 82px;
        min-width: 62px;
        flex-shrink: 0;
        gap: 10px;
      `}
      flexDirection="column"
    >
      {authors.map((a, i) => (
        <Text
          key={i}
          className={css`
            min-height: 28px;
            white-space: pre;
          `}
          type="label"
          sizing="L"
          weight="500"
          color={theme.colors.section.legend.text}
          truncate={2}
        >
          {a.name.replace(' ', '\n')}
        </Text>
      ))}
    </FlexBox>
  )
}
